export default __webpack_public_path__ + "static/media/ic_flag_de.7d35b6ca.svg";